import PaginaNaoEncontrada from '@/views/pages/commons/pagina-nao-encontrada/PaginaNaoEncontrada'
import SelecionarDominio from '@/views/pages/commons/selecionar-dominio/SelecionarDominio'
import RedirecionaEditarUsuario from '@/views/pages/commons/perfil/RedirecionaEditarUsuario'
import NaoAutorizado from '@/views/pages/commons/nao-autorizado/NaoAutorizado'

export default [
    {
        path: '/selecionar-dominio',
        name: 'SelecionarDominio',
        component: SelecionarDominio
    },
    {
        path: '/perfil',
        name: 'RedirecionarEditarUsuario',
        component: RedirecionaEditarUsuario
    },
    {
        path: '/nao-autorizado',
        name: 'NaoAutorizado',
        component: NaoAutorizado,
        meta: {
            page: {
                title: 'Sem acesso',
                subtitle: 'Seu usuário não tem acesso a esta página'
            },
            scrollToTop: true
        }
    },
    {
        path: '*',
        name: 'PaginaNaoEncontrada',
        component: PaginaNaoEncontrada,
        meta: {
            page: {
                title: 'Ooops',
                subtitle: 'Página não encontrada'
            },
            scrollToTop: true
        }
    }
]
